import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'
import { TabButton, TabButtonGroupBase } from 'src/Components/TabButton'
import { UnitTypes } from 'src/Libs/types'
import { MetricType } from '../../models/dashboard.model'

const useStyles = makeStyles()({
  container: {
    width: 'fit-content',
  },
})

interface DashboardMetricSelectorProps {
  value: MetricType
  currencySymbol: string
  onChange: (value: MetricType) => void
}

export const DashboardMetricSelector: React.FC<DashboardMetricSelectorProps> = ({ value, currencySymbol, onChange }) => {
  const { classes } = useStyles()

  const handleEnergyViewSelect = useCallback(() => {
    onChange(MetricType.Energy)
  }, [onChange])

  const handleCostViewSelect = useCallback(() => {
    onChange(MetricType.Cost)
  }, [onChange])

  return (
    <TabButtonGroupBase className={classes.container} defaultTabIndex={value === MetricType.Cost ? 0 : 1}>
      <TabButton onClick={handleCostViewSelect} value={MetricType.Cost}>
        {currencySymbol}
      </TabButton>

      <TabButton onClick={handleEnergyViewSelect} value={MetricType.Energy}>
        {UnitTypes.kiloWattHour}
      </TabButton>
    </TabButtonGroupBase>
  )
}
